function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.88869 0.293945H0.0146484V80.2279H5.88869V0.293945Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.2861 0.293945H43.4121V80.2279H49.2861V0.293945Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.2832 80.2275V74.3535L0.0117645 74.3535V80.2275L49.2832 80.2275Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.1595 10.7497L12.0684 6.16797H37.1623L35.1416 10.7497H14.1595Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.2715 6.15627V0.282227L4.95911e-05 0.282227V6.15627L49.2715 6.15627Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 11,
  y: 26,
  width: 28,
  height: 23
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0791 26.1396H38.2624V48.226H11.0791V26.1396Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.4351 31.0611C20.3874 30.1636 19.8392 29.7129 19.001 29.6546C18.1742 29.5968 17.542 30.3414 17.6043 31.2259C17.669 32.1443 18.2112 32.6218 19.0787 32.5794C19.9464 32.5366 20.4228 32.0015 20.4351 31.0611M25.2143 27.6254C24.1178 27.6175 23.2874 28.4649 23.3041 29.5745C23.3202 30.6392 24.1069 31.4218 25.1723 31.4323C26.2625 31.4434 27.0252 30.7071 27.0564 29.6143C27.0894 28.455 26.3281 27.6331 25.2143 27.6254M34.3296 33.1768C34.3766 31.7475 33.2691 30.5417 31.8717 30.5011C30.4683 30.4601 29.2679 31.5918 29.2212 32.9999C29.175 34.3927 30.3157 35.6336 31.6975 35.6936C33.0674 35.7533 34.2829 34.5909 34.3296 33.1768M27.255 41.9342C27.2309 43.9446 28.7487 45.5332 30.7004 45.5406C32.6104 45.5481 34.1322 44.0387 34.1839 42.0851C34.2372 40.0756 32.7416 38.4616 30.7932 38.4253C28.8285 38.3893 27.279 39.9259 27.255 41.9342M38.2622 37.7619C38.2828 43.9646 35.5868 47.3024 30.4687 48.1274C27.3543 48.6296 25.0002 47.1701 23.1245 44.7577C22.6379 44.1321 22.2122 43.4475 21.6678 42.8802C20.5587 41.7243 19.4864 41.6403 18.2117 42.6184C17.4936 43.1694 16.8765 43.855 16.1986 44.4623C14.4991 45.9844 12.8039 45.7032 11.7767 43.6479C10.7974 41.6888 11.0116 39.5934 11.4376 37.5486C13.6081 27.128 26.5713 22.5146 34.2929 29.4151C37.0231 31.8551 38.1981 35.0333 38.2622 37.7619",
  fill: "#EA5554"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 49.2714,
  height: 79.9339,
  fill: "white",
  transform: "translate(0 0.293945)"
})));

var SvgLandingPageIcon = function SvgLandingPageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 81,
    viewBox: "0 0 50 81",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLandingPageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/landing-page-icon.b9d0ad63.svg";
export { ForwardRef as ReactComponent };